<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <DataTable
                ref="dataTable"
                title="First Ride Pax"
                :url="api.ACTIONS.FIRST_RIDE_PAX"
                :actions-extra-main="actionsExtraMain"
                :enable-edit="false"
                :enable-delete="false"
                :enable-add="false"/>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <h3>Process Dialog</h3>
                </v-card-title>
                <v-card-text>
                    <v-switch v-model="model.with_voucher" label="With Voucher">
                    </v-switch>
                    <v-select
                            :disabled="!model.with_voucher"
                            :items="[10,20,30,40,50]"
                            label="Voucher amount"
                            append-icon="fa fa-percent"
                            v-model="model.amount"
                    ></v-select>
                    <v-textarea label="Note" v-model="model.note"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="dialog = false">Close</v-btn>
                    <v-btn flat color="primary" :disabled="loading" @click="submit">Continue</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "FirstRidePax",
        title: 'First ride pax',
        components: {LoadingComponent, DataTable},
        data() {
            return {
                dialog: false,
                model: {
                    note: null,
                    amount: null,
                    with_voucher: false
                },
                loading: false,
                selected_log: null
            }
        },
        methods: {
            submit() {
                if(this.model.with_voucher && !this.model.amount) {
                    window.getApp.$emit("SHOW_TOAST", 'complete info please', "red");
                    return;
                }
                this.loading = true;
                this.axios.put(this.api.ACTIONS.FIRST_RIDE_PAX + `/${this.selected_log}`, this.model)
                    .then(() => {
                        this.$refs.dataTable.getData();
                        window.getApp.$emit("SHOW_TOAST", 'done');
                        this.dialog = false;
                    })
                    .catch(err => {
                        try {
                            if (err.response.data.message) {
                                window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
                            } else {
                                window.getApp.$emit("SHOW_TOAST", err.message, "red");
                            }
                        } catch (e) {
                            console.log(err.message, e.message);
                        }
                    }).finally(() => this.loading = false);
            }
        },
        computed: {
            actionsExtraMain() {
                return {
                    restore: {
                        title: "Resolve",
                        icon: "check",
                        extras: {
                            color: "primary"
                        },
                        action: async (item) => {
                            this.dialog = true;
                            this.selected_log = item.id;
                        }
                    }
                };
            }
        }
    }
</script>

<style scoped>

</style>